import axios from "axios";
/**
 * The base URL for API requests, retrieved from environment variables.
 * @type {string | undefined}
 */
var API_BASE_URL = window._env_.API_BASE_URL;
/**
 * An Axios instance configured for making API requests.
 * It sets a base URL, a timeout, and default headers for JSON content.
 *
 * @type {import("axios").AxiosInstance}
 */
var serviceApi = axios.create({
    baseURL: API_BASE_URL, // Base URL for all requests
    timeout: 10000, // Request timeout in milliseconds (10 seconds)
    headers: {
        "Content-Type": "application/json", // Default content type for requests
    },
});
export default serviceApi;
